import { getConfig } from '@constants';

export enum EBrowser {
	EDGE = 'edge',
	IE9 = 'ie9',
	IE10 = 'ie10',
	IE11 = 'ie11',
	IE = 'ie',
	FireFox = 'ff',
	CHROME = 'chrome',
	SAFARI = 'safari',
	OPERA = 'opera',
	YANDEX = 'yandex',
	SAMSUNG = 'samsung',
	MIUI = 'miui',
	UC = 'uc',
	UNKNOWN = ''
}

export interface IUserAgentInfo {
	ua: unknown;
	browser?: EBrowser;
	os: 'win10' | 'winvista' | 'win7' | 'win8' | 'winxp' | 'winnt' | 'mac' | 'linux' | 'nix' | '';
	isTouch: boolean;
	mobileType: 'windows' | 'android' | 'blackberry' | 'undetected' | 'iOS' | '';
	isTablet: boolean;
	isMobile: boolean;
}

export function getUserAgentInfo(): IUserAgentInfo {
	const ua = IS_SSR ? getConfig().userAgent : navigator?.userAgent;
	let browser: EBrowser;

	switch (true) {
		case ua.includes('YaBrowser'):
			browser = EBrowser.YANDEX;
			break;
		case ua.includes('Samsung'):
			browser = EBrowser.SAMSUNG;
			break;
		case (/UCBrowser|UCWEB/.test(ua)):
			browser = EBrowser.UC;
			break;
		case (ua.includes('Miui')):
			browser = EBrowser.MIUI;
			break;
		case ( /\bOpera\W\d/.test(ua) || /\bOPR\W\d/i.test(ua)):
			browser = EBrowser.OPERA;
			break;
		case ua.includes('Edg'):
			browser = EBrowser.EDGE;
			break;
		case ua.includes('MSIE 9'):
			browser = EBrowser.IE9;
			break;
		case ua.includes('MSIE 10'):
			browser = EBrowser.IE10;
			break;
		case (ua.includes('MSIE 11') || ua.includes('rv:11')):
			browser = EBrowser.IE11;
			break;
		case (/MSIE\s\d/.test(ua) || typeof MSPointerEvent !== 'undefined'):
			browser = EBrowser.IE;
			break;
		case ua.includes('Firefox'):
			browser = EBrowser.FireFox;
			break;
		case !!(/Chrom(e|ium)\W\d|CriOS\W\d/.test(ua) && (!IS_SSR ? window?.chrome : true)):
			browser = EBrowser.CHROME;
			break;
		case ua.includes('Safari') && !ua.includes('Chrome'):
			browser = EBrowser.SAFARI;
			break;
		default:
			browser = EBrowser.UNKNOWN;
	}

	return {
		ua,
		browser,
		os: ua.includes('Windows NT 10') ? 'win10' : ua.includes('Windows NT 6.0') ? 'winvista' : ua.includes('Windows NT 6.1') ? 'win7' : /Windows NT 6\.\d/.test(ua) ? 'win8' : ua.includes('Windows NT 5.1') ? 'winxp' : /Windows NT [1-5]\./.test(ua) ? 'winnt' : ua.includes('Mac') ? 'mac' : ua.includes('Linux') ? 'linux' : ua.includes('X11') ? 'nix' : '',
		isTouch: (!IS_SSR && document) && 'ontouchstart' in document?.documentElement,
		mobileType: /IEMobile|Windows Phone|Lumia/i.test(ua) ? 'windows' : /iPhone|iP[oa]d/.test(ua) ? 'iOS' : ua.includes('Android') ? 'android' : /BlackBerry|PlayBook|BB10/.test(ua) ? 'blackberry' : ua.includes('Mobile Safari') ? 'undetected' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 'undetected' : '',
		isTablet: /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua.toLowerCase()),
		isMobile: /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(ua),
	};
}
